import { Helmet } from "react-helmet-async";

const BRAND_SUFFIX = "Mabuhay Barista & Cocktail Catering";
const SITE_ORIGIN = "https://mabuhay-cocktail.de";

export default function Seo({ title, description, noindex = false, jsonLd = null, path = null }) {
  const fullTitle = title.toLowerCase().includes("mabuhay") ? title : `${title} | ${BRAND_SUFFIX}`;
  const canonical = path !== null ? `${SITE_ORIGIN}${path === "/" ? "/" : path}` : null;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {canonical && <meta property="og:url" content={canonical} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
